import styled from 'styled-components'

const customLG = '1679px'
const customMD = '1279px'
const customSM = '1023px'
const customXS = '767px'

export const FooterOuter = styled.footer`
  background: ${({ theme }) => theme.webMktPalette.background.dark};
  padding: 0 48px 48px;

  .Footer__Text--Bold {
    font-weight: 700;
  }

  a:hover {
    text-decoration: underline;
    transition: none;
    color: #fff;
  }

  a,
  p {
    color: #fff;
  }

  @media screen and (max-width: ${customLG}) {
    padding: 0 40px 48px;
  }

  @media screen and (max-width: ${customMD}) {
    padding: 0 32px 48px;
  }

  @media screen and (max-width: ${customSM}) {
    padding: 0 24px 48px;
  }

  @media screen and (max-width: ${customXS}) {
    padding: 0 0 48px;
  }
`

export const FooterInner = styled.div`
  display: grid;
  max-width: 1584px;
  margin: 0 auto;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  grid-column-gap: 24px;
  align-items: flex-start;

  @media screen and (max-width: ${customLG}) {
    max-width: 100%;
  }

  @media screen and (max-width: ${customSM}) {
    grid-template-columns: repeat(8, minmax(0, 1fr));
    grid-column-gap: 16px;
  }
`

export const LanguageSelector = styled.div`
  display: flex;
  margin-left: 32px;
  align-items: center;
  position: relative;
  padding: 12px 16px;
  height: 48px;
  width: 180px;
  border: 1px solid #414244;
  box-sizing: border-box;
  cursor: pointer;
  z-index: 10;

  &.LanguageSelector--Active {
    ul {
      display: block;
    }

    svg:last-of-type {
      transform: rotate(180deg);
    }
  }

  svg {
    width: 16px;
    height: 16px;
    object-fit: contain;
    transition: 0.2s ease;
  }

  .LanguageSelector__CurrentLocale,
  svg {
    pointer-events: none;
  }

  > .LanguageSelector__CurrentLocale {
    margin-left: 13px;
    margin-right: auto;
  }

  ul {
    position: absolute;
    display: none;
    top: 100%;
    left: -1px;
    width: 180px;
    box-sizing: border-box;
    border-left: 1px solid #414244;
    border-right: 1px solid #414244;
    border-bottom: 1px solid #414244;
    background: ${({ theme }) => theme.webMktPalette.background.dark};

    li {
      padding: 8px 0px 8px 16px;

      a:hover {
        text-decoration: none;
      }

      p {
        color: ${({ theme }) => theme.webMktPalette.text.secondaryDark};
      }

      &.LanguageSelector__Locale--Active,
      &:hover {
        p {
          color: ${({ theme }) => theme.webMktPalette.text.primaryWhite};
        }
      }

      &:hover {
        background-color: ${({ theme }) => theme.webMktPalette.text.actionLight};
      }

      &.LanguageSelector__Locale--Active {
        background-image: url('/steam-img/check-logo.svg');
        background-repeat: no-repeat;
        background-position: 148px 50%;
      }
    }
  }

  @media screen and (max-width: ${customXS}) {
    margin: 0;
  }
`

export const FooterTopHat = styled.div`
  padding: 40px 0 24px;
  grid-column: 1 / 13;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.webMktPalette.grayNeutral[65]};

  .Footer__UIPathLogo {
    svg {
      vertical-align: middle;
    }
    &:hover svg path {
      fill: ${({ theme }) => theme.webMktPalette.icon.orange};
    }
  }

  > div:first-of-type {
    display: flex;
    align-items: center;
    margin-left: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .Footer__TopHatLink {
    color: #fff;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: center;

    &:hover {
      text-decoration: underline;
      color: ${({ theme }) => theme.webMktPalette.text.primaryWhite};
    }

    > div {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 12px;
      width: 24px;
      height: 24px;
      border-radius: 30px;
    }
  }

  .Footer__TopHatLink:hover {
    div:before {
      content: '';
      width: 40px;
      height: 40px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      border-radius: 30px;
      background: rgba(255, 255, 255, 0.1);
    }
  }

  > div > a:not(:first-child) {
    height: 32px;
    margin-left: 24px;
    padding-left: 24px;
    position: relative;
    border-left: 1px solid ${({ theme }) => theme.webMktPalette.grayNeutral[65]};
  }

  @media screen and (max-width: ${customSM}) {
    grid-column: 1 / 9;
  }

  @media screen and (max-width: ${customXS}) {
    flex-wrap: wrap;
    justify-content: center;
    row-gap: 16px;
    column-gap: 54px;
    align-items: center;
    padding-bottom: 16px;

    .Footer__TopHatLink {
      font-size: 12px;
      line-height: 16px;

      > div {
        width: 16px;
        height: 16px;
      }

      &:hover > div {
        &:before {
          width: 32px;
          height: 32px;
        }
      }
    }

    > div:first-of-type {
      width: 100%;
      border-top: 1px solid ${({ theme }) => theme.webMktPalette.grayNeutral[65]};
      padding-top: 16px;
      justify-content: center;
      order: 3;

      > a {
        justify-content: center;
      }
    }
  }
`

export const FooterColumn = styled.div<{
  $columnStart: number
  $columnEnd: number
  $columns: number
  $menuIndex: number
}>`
  ${({ theme, $columnStart, $columnEnd, $columns, $menuIndex }) => {
    return `
      display: grid;
      grid-column: ${$columnStart} / ${$columnEnd};
      grid-template-columns: repeat(${$columns}, minmax(0, 1fr));
      grid-column-gap: 24px;

      div:nth-of-type(1) {
        grid-column: 1 / ${$columns + 1};
        border-bottom: 1px solid ${theme.webMktPalette.grayNeutral[65]};
        padding-top: 32px;
        padding-bottom: 16px;
        margin-bottom: 28px;

        p {
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin: 0;
          color: ${theme.webMktPalette.grayNeutral[45]};
        }

        span {
          display: none;
          border-bottom: 1px solid ${theme.webMktPalette.grayNeutral[65]};
          width: 100%;
          margin-left: 16px;
        }
      }

      div:nth-of-type(2) {
        grid-column: 1 / 3;
      }

      div:nth-of-type(3) {
        grid-column: 3 / 5;
      }

      @media screen and (max-width: ${customSM}) {
        grid-column: ${$menuIndex % 2 != 0 ? `1 / 5` : `5 / 9`};
        grid-template-columns: repeat(4, minmax(0, 1fr));

        div:nth-of-type(1) {
          grid-column: 1 / 5;
        }
      }

      @media screen and (max-width: ${customXS}) {
        ${$columns === 4 ? `grid-column: 1 / 9;` : ``}

        div:nth-of-type(1) {
          display: flex;
          align-items: center;
          border-bottom: none;
          margin-bottom: 0px;

          span {
            display: block;
          }
        }
      }
    `
  }}

  li + li {
    margin-top: 16px;
  }

  a {
    font-size: 14px;

    &.Footer__Text--Bold {
      font-size: 16px;
    }
  }

  ul + h6 {
    margin-top: 24px;
  }

  h6 + ul {
    margin-top: 16px;
  }

  .Footer__Group-Title p,
  h6 {
    line-height: 24px;
    font-size: 16px;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 500;
    color: ${({ theme }) => theme.webMktPalette.grayNeutral[45]};
  }

  @media screen and (max-width: ${customXS}) {
    grid-column: 1 / 9;
    padding: 0 24px;

    .Footer__Group-Title p,
    a.Footer__Text--Bold,
    h6 {
      font-size: 14px;
    }

    .Footer__Group-Title p {
      white-space: nowrap;
    }
  }
`

export const FooterSitemap = styled.div`
  display: grid;
  grid-column: 1 / 13;
  padding: 0 0 32px;
  border-bottom: 1px solid ${({ theme }) => theme.webMktPalette.grayNeutral[65]};
  align-items: start;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  grid-column-gap: 24px;

  @media screen and (max-width: ${customSM}) {
    grid-column: 1 / 9;
    grid-template-columns: repeat(8, minmax(0, 1fr));
    grid-column-gap: 16px;
  }

  @media screen and (max-width: ${customXS}) {
    grid-column: 1 / 9;
    padding: 0 0 24px;
  }
`

export const FooterSocial = styled.div`
  grid-column: 1 / 13;
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  border-bottom: 1px solid ${({ theme }) => theme.webMktPalette.grayNeutral[65]};
  padding: 16px 0;
  grid-column-gap: 24px;

  .Footer__SocialNetwork {
    grid-column: 1 / 4;
    display: flex;

    > div {
      display: flex;
    }
  }

  .Footer__SocialNetwork-IntroText {
    white-space: nowrap;
    margin: 0;
  }

  svg {
    width: 24px;
    height: 24px;
    object-fit: contain;
    vertical-align: middle;
  }

  ul {
    display: flex;
    gap: 32px;
    margin-left: 32px;
    align-items: center;

    li a:hover svg path {
      fill: ${({ theme }) => theme.webMktPalette.icon.white};
    }
  }

  .popover {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1060;
    width: 276px;
    max-width: 276px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    z-index: 1;

    &.open {
      display: block;
    }

    .parrow {
      position: absolute;
      display: block;
      width: 1rem;
      height: 0.5rem;
      margin: 0 0.3rem;
      box-sizing: border-box;
      bottom: calc((0.5rem + 1px) * -1);
      left: 0;
      right: 0;
      margin: 0 auto;

      &:before,
      &:after {
        position: absolute;
        display: block;
        content: '';
        border-color: transparent;
        border-style: solid;
        box-sizing: border-box;
        bottom: 1px;
        border-width: 0.5rem 0.5rem 0;
        border-top-color: rgba(255, 255, 255, 1);
      }
    }

    .popover-body {
      padding: 1px;
      overflow: hidden;

      img {
        width: 100%;
        height: auto;
      }
      a {
        color: #0067df;
      }
      p {
        text-align: center;
        margin: 0;
        color: #4a4a4a;
        &:last-child {
          margin-bottom: 10px;
        }
      }

      .qrcode-section {
        .wc-qr-tablet,
        .wc-qr-mobile {
          display: none;
        }
      }
    }
  }

  @media screen and (max-width: ${customMD}) {
    display: flex;
    flex-direction: column;

    .Footer__SocialNetwork {
      width: 100%;
      justify-content: center;
      margin-top: 0;
    }

    .Footer__SocialNetwork-IntroText {
      display: none;
    }

    ul {
      margin-left: 0;
      gap: 96px;
    }
  }

  @media screen and (max-width: ${customSM}) {
    grid-column: 1 / 9;

    .popover {
      .popover-body {
        .qrcode-section {
          .wc-qr-desktop,
          .wc-qr-mobile {
            display: none;
          }

          .wc-qr-tablet {
            display: block;
          }
        }
      }
    }
  }

  @media screen and (max-width: ${customXS}) {
    ul {
      gap: 48px;
      flex-wrap: wrap;
      justify-content: center;
    }

    border-top: 1px solid ${({ theme }) => theme.webMktPalette.grayNeutral[65]};
    margin-top: 32px;

    .popover {
      width: 100%;
      max-width: 100%;
      top: 20px !important;
      left: 0px !important;
      border-radius: 0px;
      position: relative;
      padding: 20px;
      border: none;

      .parrow {
        display: none;
      }

      .popover-body {
        display: flex;

        p {
          text-align: left;
        }

        .qr-img {
          width: calc(50% - 20px);
        }

        .qrcode-section {
          width: calc(50% - 20px);
          margin-left: 5px;

          .wc-qr-desktop,
          .wc-qr-tablet {
            display: none;
          }

          .wc-qr-mobile {
            display: block;
          }
        }
      }
    }
  }
`

export const FooterLegal = styled.div`
  display: grid;
  grid-column: 1 / 13;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  grid-column-gap: 24px;
  padding: 24px 24px 0;

  // one trust
  #ot-sdk-btn {
    background: none !important;
    border: none !important;
    padding: 0 !important;
    font-size: 12px !important;
    line-height: 16px !important;
    color: #595a5c !important;

    &:hover {
      color: #fff !important;
    }
  }

  p {
    text-align: center;
    grid-column: 1 / 13;
    font-size: 12px;
    line-height: 16px;
    margin: 16px 0 0;
  }

  p,
  a {
    color: #595a5c;
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    grid-column: 1 / 13;
    column-gap: 36px;

    > li:not(:last-of-type) {
      a {
        position: relative;

        &:before {
          content: '\\2022';
          position: absolute;
          font-size: 12px;
          line-height: 16px;
          color: #595a5c;
          width: 36px;
          text-align: center;
          left: 100%;
          top: 0;
        }
      }
    }
  }

  a {
    font-size: 12px;
    line-height: 16px;
    &.nohover {
      text-decoration: none;
      color: inherit;
    }
  }
  .icon {
    display: inline-block;
    fill: currentcolor;
    height: 16px;
    position: relative;
    top: -0.0625em;
    vertical-align: middle;
    width: 16px;
    margin-left: 5px;
  }

  @media screen and (max-width: ${customSM}) {
    grid-column: 1 / 9;
    grid-template-columns: repeat(8, minmax(0, 1fr));
    grid-column-gap: 16px;

    > p,
    ul {
      grid-column: 1 / 9;
    }
  }

  @media screen and (max-width: ${customXS}) {
    ul {
      column-gap: 18px;
      > li:not(:last-of-type) {
        a {
          &:before {
            width: 18px;
          }
        }
      }
    }
  }
`
